import {
    Button, Paper
} from '@mui/material';
import { PaperSaveLoader } from '@tsp-ui/core/components';
import Page from '@views/components/Page';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import styles from './ClientAddInvestorPage.module.scss';
import ClientInvestorForm from './components/ClientInvestorForm';


export function ClientAddInvestorPage() {
    const [ loading, setLoading ] = useState(false);
    const [ disableSubmit, setDisableSubmit ] = useState(true);

    return (
        <Page
            variant="centered"
            header="Add Investor"
        >
            <Paper className={styles.root}>
                <ClientInvestorForm
                    setLoading={setLoading}
                    setDisableSubmit={setDisableSubmit}
                />

                <div className={styles.buttons}>
                    <Button
                        component={Link}
                        replace
                        to=".."
                    >
                        Cancel
                    </Button>

                    <Button
                        key="save"
                        form={ClientInvestorForm.formID}
                        variant="contained"
                        type="submit"
                        disabled={disableSubmit}
                    >
                        Next
                    </Button>
                </div>

                <PaperSaveLoader loading={loading} />
            </Paper>
        </Page>
    );
}
